<mat-sidenav-container [hasBackdrop]="false" [class.sidenav-mobile]="sidenavMobileMode()">
  <mat-sidenav [opened]="isOpened()" [mode]="sidenavMobileMode() ? 'over' : 'side' " [disableClose]="!sidenavMobileMode()" [class.sidenav-mobile]="sidenavMobileMode()"  >
    <div class="title-group">
      <img class="logo" src="logo.png" alt="logo">
      @if(sidenavMobileMode() && isOpened()) {
        <button mat-icon-button aria-label="Close menu" (click)="isOpened.set(false)" >
          <mat-icon>close</mat-icon>
        </button>
      } @else if (isOpened()) {
          <button mat-icon-button aria-label="Close menu" (click)="isOpened.set(false)">
              <mat-icon>menu</mat-icon>
          </button>
      }
    </div>
      <ng-content select="[sidebar]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content >
    @if(sidenavMobileMode() && isOpened()) {
      <div class="backdrop-layer" [class.has-backdrop]="sidenavMobileMode() && isOpened()" @fadeIn></div>
    }
      <app-topbar>
          @if(!isOpened()) {
              <div class="nav-open-button" >
                  <button mat-icon-button aria-label="Open menu" (click)="isOpened.set(true)">
                      <mat-icon>left_panel_open</mat-icon>
                  </button>
              </div>
          }
          <ng-content select="[topbar]"></ng-content>
      </app-topbar>
    <div class="sidenav-content-main" [class.main-mobile]="sidenavMobileMode()">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
